import { NgModule } from "@angular/core";

import { FileSaverService } from "./file-saver.service";

/**
 * Module for saving files
 *
 * @export
 */
@NgModule({
  providers: [FileSaverService]
})
export class FileSaverModule {}
